import { render, staticRenderFns } from "./PropuestaTecnicaLisp.vue?vue&type=template&id=0a23ac5c&scoped=true&"
import script from "./PropuestaTecnicaLisp.vue?vue&type=script&lang=js&"
export * from "./PropuestaTecnicaLisp.vue?vue&type=script&lang=js&"
import style0 from "./PropuestaTecnicaLisp.vue?vue&type=style&index=0&id=0a23ac5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a23ac5c",
  null
  
)

export default component.exports